import React from 'react';
import cn from 'classnames';
import css from "./style.scss"

const Plan=(props)=>{
  const onSelect = () => {
    props.onSelect(props.plan)
  }
  return (
    <div onClick={onSelect} className={cn(css.plan, props.selected === props.plan ? css.selected : "")}>
      <h4>{props.title}</h4>
      {props.children}
      <div className={css.price}>
        {props.price}€
      </div>
      <div className={css.subprice}>Every {props.period}</div>
    </div>
  )
}

class NormalPlansUI extends React.Component {
  componentDidMount(){
    this.props.onSelect("awesome", "awesome-monthly")
  }
  render(){
    let period_plans=this.props.plans[this.props.selectedPeriod]
    return (
      <div className={css.container}>
        <div className={css.text}>
        {!this.props.settings &&
          <p>
            You just found a <b>Premium</b> feature!
            <br/><br/>
            If you want to unlock this feature, <b>choose a plan</b>:
          </p>
        }
        {this.props.settings &&
          <p>
            Choose a plan:
          </p>
        }
        <div>
          <div className={css.plans}>
            <Plan
              plan="awesome"
              title={period_plans.awesome.name}
              period={period_plans.awesome.period}
              price={period_plans.awesome.price}
              selected={this.props.selectedPlan}
              onSelect={this.props.onSelect}>
              <ul>
                <li>1 additional Instagram Account</li>
                <li>Up to <b>2</b> Team Members</li>
                <li>Export and download all your data</li>
                <li>Remove all ads</li>
                <li>No 7 days limit for your stories!</li>
              </ul>
            </Plan>
            <Plan
              plan="business"
              title={period_plans.business.name}
              period={period_plans.business.period}
              price={period_plans.business.price}
              selected={this.props.selectedPlan}
              onSelect={this.props.onSelect}
            >
              <ul>
                <li>Add up to <b>6</b> Instagram Accounts</li>
                <li>Up to <b>10</b> Team Members</li>
                <li>Export and download all your data</li>
                <li>Remove all ads</li>
                <li>No 7 days limit for your stories!</li>
              </ul>
            </Plan>
          </div>
          <label className={css.yearly_check}><input type="checkbox" onChange={this.props.onChangePeriod}/> Yearly (2 months free!) </label>
        </div>
        </div>
      </div>
    )
  }
}

export default NormalPlansUI



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/ui/normal_plans.js